import React from 'react'

import { Accordion, Icon, Text } from 'components'

type AccordionWrapperProps = {
  title: string
  children?: React.ReactChild
  displayContextMenu?: boolean
  refreshHeight?: number
  onContextMenuClick?: () => void
  ContextItems?: Array<React.ReactElement>
}

const AccordionWrapper = ({
  title,
  children,
  displayContextMenu,
  refreshHeight,
  onContextMenuClick,
  ContextItems,
}: AccordionWrapperProps) => (
  <Accordion
    customIcon={<Icon color="gray5" icon={['fa', 'caret-right']} />}
    customIconRotate={90}
    contextMenuIcons={
      ContextItems
        ? ContextItems
        : [<Icon key="context-menu-icon-1" color="gray5" icon={['fa', 'ellipsis-v']} mx="8px" />]
    }
    displayContextMenu={displayContextMenu}
    refreshHeight={refreshHeight}
    onContextMenuClick={onContextMenuClick}
    title={
      <Text fontWeight="bold" fontSize={16}>
        {title}
      </Text>
    }
    classPrefix="lead-details-left-section"
    open={false}
  >
    {children}
  </Accordion>
)

export default AccordionWrapper
